import ApiClient from "../ApiClient";
import PaymentListFilter from "../../models/admin/payment/PaymentListFilter";
import PaymentListFilterValue from "../../models/admin/payment/PaymentListFilterValue";
import PaymentListPagedResult from "../../models/admin/payment/PaymentListPagedResult";

export default class PaymentApiClient {
  apiClient: ApiClient;
  urlPrefix: string = "admin/payments/";

  constructor() {
    this.apiClient = new ApiClient();
  }

  async getSearchFilters() {
    const filters = await this.apiClient.get(`${this.urlPrefix}search/filters`);

    return filters as PaymentListFilter;
  }

  async search(
    filter: PaymentListFilterValue,
    page?: number,
    pageItems?: number
  ) {
    const payments = await this.apiClient.post(this.urlPrefix + "search", {
      ...filter,
      page: page,
      pageSize: pageItems
    });
    return payments as PaymentListPagedResult;
  }

  async searchExport(filter: PaymentListFilterValue) {
    await this.apiClient.download(
      this.urlPrefix + "search/export",
      "post",
      filter
    );
  }

  async getNewGroup(paymentRequestTypeId: number, date: Date) {
    const group = await this.apiClient.get(
      `${this.urlPrefix}new-group?paymentRequestTypeId=${paymentRequestTypeId}` +
        `&date=${date}`
    );

    return group as string;
  }

  async updateStatuses(
    paymentRequestTypeId: number,
    date: Date,
    paymentIds: number[]
  ) {
    await this.apiClient.put(this.urlPrefix + "statuses", {
      paymentRequestTypeId: paymentRequestTypeId,
      date: date,
      paymentIds: paymentIds
    });
  }
}
